// Modular imports for better tree-shaking - only import what we use
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/database';

declare module '#app' {
  interface NuxtApp {
    $firebase: {
      instance: typeof firebase;
      app: firebase.app.App;
      auth: firebase.auth.Auth;
      database: firebase.database.Database;
    };
  }
}

export default defineNuxtPlugin((nuxtApp) => {
  const config = nuxtApp.$config.public;
  const firebaseConfig = {
    apiKey: config.firebaseApiKey,
    authDomain: config.firebaseAuthDomain,
    projectId: config.firebaseProjectId,
    storageBucket: config.firebaseStorageBucket,
    messagingSenderId: config.firebaseMessagingSenderId,
    appId: config.firebaseAppId,
    databaseURL: config.firebaseDbUrl,
    measurementId: config.firebaseMeasurementId,
  };

  firebase.initializeApp(firebaseConfig);

  firebase
    .auth()
    .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
    .then(() => {})
    .catch((error) => {
      console.error('Error setting Firebase Auth persistence: ', error);
    });

  return {
    provide: {
      firebase: {
        instance: firebase,
        app: firebase.app(),
        auth: firebase.auth(),
        database: firebase.database(),
      },
    },
  };
});
